import { Divider, Typography } from "antd";

const FAQ = () => {
    return (
        <div>
            <Typography.Title level={3}>About Our Ceremony</Typography.Title>
            <Typography.Text>
                We have decided to have a private ceremony to celebrate our marriage. There will be no guests or
                public event held. There will be no livestream or recording. The only parties involved are the
                officiant, two witnesses, and us.
            </Typography.Text>

            <Divider />

            <Typography.Title level={3}>Why aren't we having a ceremony?</Typography.Title>
            <Typography.Text>
                Both of us never expected to get married or have a wedding. The fact that we decided to get married was
                a surprise to both us. We are very private and want to keep the ceremony private.
                Therefore, we will not have a public wedding or reception. In fact, it's just going to be L and R and no one else.
                We wish to spend this special day with just the two of us in a quiet and intimate setting.
            </Typography.Text>

            <Divider />

            <Typography.Title level={3}>Where is it taking place?</Typography.Title>
            <Typography.Text>
                We love the Seattle area. It's our favorite place to go. We've been there a few times and always
                have more ideas for things to do there. One of our ideas was to take a ferry from Washington to Canada. 
                Victoria, BC is a short ferry trip from Seattle. It's the next destination on our list of explorations.
                Therefore, we decided to have our ceremony at the City Hall in Victoria, BC.
            </Typography.Text>

            <Divider />

            <Typography.Title level={3}>Why did you pick that date?</Typography.Title>
            <Typography.Text>
                We're nerds, and we like to have meaning behind everything. September 8 is the date that R proposed to L.
                It also happens that 8 is both of our second favorite number. It seems only fitting that we take a ferry in
                the same region on the same day that we got engaged.
            </Typography.Text>

            <Divider />

            <Typography.Title level={3}>Will there be a reception later?</Typography.Title>
            <Typography.Text>
                No, we will not be having a reception later. We may have a small celebration with close family and 
                friends at a later date, but nothing formal. If you're interested in celebrating with us, please reach out
                to either L or R and we'd be happy to arrange something informal.
            </Typography.Text>
        </div>
    );
};

export default FAQ;
